import { twMerge } from 'tailwind-merge';

export function Label({
  htmlFor,
  children,
  className = '',
}: {
  children: React.ReactNode;
  className?: string;
  htmlFor: string;
}) {
  return (
    <label htmlFor={htmlFor} className={twMerge('font-aribaubold text-sm', className)}>
      {children}
    </label>
  );
}
